import React from "react";
import { useNavigate } from "react-router-dom";
import "./Ghadia.css";
import SectionDivider from "../../common/SectionDivider";

const colors = [
  "#3B00FF", "#0A7B00", "#FF8C00", "#FF0000",
  "#D600FF", "#B36A00", "#774300", "#6D8F00",
  "#FF00C8", "#00E4FF",
];

const Ghadia1to30 = () => {
  const navigate = useNavigate();

  const boxes = Array.from({ length: 30 }, (_, i) => i + 1);

  return (
       <>
        <SectionDivider title="1-30 ઘડિયા" />
    <div className="g1-main">

      {/* SECTION 1 → 1–10 */}
      <div className="section-title">1-10 ઘડિયા</div>
      <div className="grid-box">
        {boxes.slice(0, 10).map((num, i) => (
          <div
            key={i}
            className="num-card"
            style={{ color: colors[i % colors.length] }}
            onClick={() => navigate(`/ghadiya/${num}`)}
          >
            {num}
          </div>
        ))}
      </div>

      {/* SECTION 2 → 11–20 */}
      <div className="section-title">11-20 ઘડિયા</div>
      <div className="grid-box">
        {boxes.slice(10, 20).map((num, i) => (
          <div
            key={i}
            className="num-card"
            style={{ color: colors[i % colors.length] }}
            onClick={() => navigate(`/ghadiya/${num}`)}
          >
            {num}
          </div>
        ))}
      </div>

      {/* SECTION 3 → 21–30 */}
      <div className="section-title">21-30 ઘડિયા</div>
      <div className="grid-box">
        {boxes.slice(20, 30).map((num, i) => (
          <div
            key={i}
            className="num-card"
            style={{ color: colors[i % colors.length] }}
            onClick={() => navigate(`/ghadiya/${num}`)}
          >
            {num}
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default Ghadia1to30;
